'use client';

import { useLayoutEffect } from 'react';
import { usePathname } from '@/i18n/navigation';

export default function NavScrollHandler() {
  const pathname = usePathname();

  useLayoutEffect(() => {
    const nav = document.querySelector<HTMLElement>('.t-nav');
    if (!nav) return;

    const check = (forceAtTop?: boolean) => {
      const navH = nav.getBoundingClientRect().height;
      const darkSections = document.querySelectorAll<HTMLElement>(
        '[data-dark-hero], [data-nav-dark]',
      );
      let isDark = false;
      darkSections.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top <= navH && r.bottom > 0) isDark = true;
      });
      // forceAtTop=true sur navigation : ignore scrollY stale de la page précédente
      const atTop = forceAtTop === true ? true : window.scrollY < navH;
      // Atomic update — un seul className assignment, évite tout état intermédiaire
      nav.className = ['t-nav',
        isDark ? 't-nav--dark' : '',
        atTop ? 't-nav--top' : '',
        !atTop ? 't-nav--scrolled' : '',
      ].filter(Boolean).join(' ');
    };

    // Sur changement de page : check synchrone avec atTop forcé
    // → useLayoutEffect fire avant le paint → 0 frame de flash visible
    check(true);

    const handleScroll = () => check();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pathname]);

  return null;
}
